<template>
  <div>
    <div @click="visible = true">
      <a-button
        v-if="canEdit"
        type="primary"
        style="background: #ff8c18; border: 1px solid #ff8c18"
        icon="plus"
      >
        添加
      </a-button>
    </div>

    <a-modal
      :visible="visible"
      title="添加物资"
      :footer="null"
      @cancel="visible = false"
    >
      <a-form :form="form" :colon="false" @submit="handleSubmit">
        <a-form-item
          label="分类"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            @change="onTypeChange"
            v-decorator="[
              'category',
              { rules: [{ required: true, message: '请选择！' }] },
            ]"
          >
            <a-select-option
              v-for="item in ['办公文具用品', '电脑周边', '打印耗材', '劳保用品']"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

      

        <a-form-item
          label="物资名"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            @change="onNameChange"
            show-search
            :filter-option="filterOption"
            v-decorator="[
              'id',
              { rules: [{ required: true, message: '请选择！' }] },
            ]"
          >
            <a-select-option
              v-for="item in list"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>


        <a-form-item
          label="单位"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select v-decorator="['unit']" :disabled="true">
            <a-select-option
              v-for="item in unitList"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="单价"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input-number
            :formatter="$inputNumberFormat"
            :disabled="true"
            :min="0"
            style="width: 100%"
            v-decorator="['price']"
          />
        </a-form-item>

        <a-form-item
          :label="ifStorage?'新入库数量':'申领数量'"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input-number
            :min="0"
            style="width: 100%"
            v-decorator="[
              'num',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <div class="right">
          <a-space>
            <a-button type="primary" html-type="submit">保存</a-button>
            <a-button @click="visible = false">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchList } from "@/api/oa/purchaseMaterials";

export default {
  props:{
    ifStorage: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      subTypeList: [], // 子类型列表
      list: [], // 品名列表
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("giftType");
    },
    unitList() {
      return this.findDataDict("invUnit");
    },
  },

  methods: {
    filterOption(input, option) {
      const label = this.list.find((item) => item.id === option.key).name;
      return label.indexOf(input) !== -1;
    },
    // 选中父分类
    onTypeChange(value) {
      fetchList({
        category: value,
        pageSize: 999,
      }).then((res) => {
        if (res && Array.isArray(res.list)) {
          this.list = res.list;
          this.form.setFieldsValue({
            id: null,
            unit: null,
            price: null,
          });
        }
      });
    },

    // 选中子分类
    onSubTypeChange(value) {
      fetchList({
        typeInv: this.form.getFieldValue("typeInv"),
        typeSub: value,
        pageSize: 999,
      }).then((res) => {
        if (res && Array.isArray(res.list)) {
          this.list = res.list;
          this.form.setFieldsValue({
            id: null,
            quantity: null,
            unit: null,
            unitPrice: null,
          });
        }
      });
    },

    // 选中品名
    onNameChange(value) {
      const obj = this.list.find((item) => item.id === value);
      if (obj) {
        this.form.setFieldsValue({
          unit: obj.unit,
          price: obj.price,
        });
      }
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const { id, amount } = values;
          const obj = this.list.find((item) => item.id === id);

          this.$emit("add", {
            ...values,
            name: obj.name,
            spec: obj.spec,
            color: obj.color,
            remark: obj.remark,
          });

          this.visible = false;
          this.form.resetFields();
        }
      });
    },
  },
};
</script>